const schema = {
  fieldsets: [],
  properties: [],
  required: [],
};

export default schema;
